export const getQuery = () => {
    let query = window.location.search.substring(1);
    let res = {};
    query
      .split('&')
      .forEach(item => {
        let [key, val] = item.split('=');
        key && (res[key] = val);
      });
    return res;
}

// 字符串缩短
export const trunc = (str, left, right) => {
  if (str.length < (left + right)) {
    return str;
  }
  return str.slice(0, left) + '...' + str.slice(-right);
}

// 异步加载高德地图
export const loadMap = () => {
  return new Promise((resolve, reject) => {
    global.window.init = () => {
      resolve(global.window.AMap);
    };
    const script = global.document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=19e97b8f7c11df0365a2993400a2f468&plugin=AMap.Geocoder,Map3D,AMap.DistrictLayer&callback=init';
    script.onerror = reject;
    global.document.head.appendChild(script);
  });
};
